/**
 * Created by FLI on 2015-03-03.
 */
angular.module('ffApp').controller('LightboxController', ['$scope', function($scope)
{
	$scope.loading = false;

	$scope.open = function( comment_id )
	{
		if( $scope.loading || parseInt( comment_id ) <= 0 )
		{
			return;
		}
		$scope.loading = true;

		var $lightbox = jQuery('.lightbox');
		var $dim = jQuery('.lightbox-dim-content');

		$dim.show().switchClass( "transparent", "opaque", 400 );
		$lightbox.show().switchClass( "transparent", "opaque", 400 );

		var endpoint = templateDirectoryUrl + '/ajax_load_lightbox.php';
		var data = {
			comment_id: comment_id,
			window_width: jQuery( window ).width()
		};

		if( typeof navmenu == "object" ) {
			navmenu.close();
			navmenu.hide();
		}

		jQuery.get( endpoint, data, function(response, status, xhr)
		{
			if( status == "error" ) { alert("Ett kommunikationsfel uppstod. Var god f&ouml;rs&ouml;k igen. "+xhr.status+" "+xhr.statusText); return; }

			$lightbox.find('.content').html( response );

			$scope.loading = false;
		});
	};

	$scope.close = function()
	{
		var $lightbox = jQuery('.lightbox');
		var $dim = jQuery('.lightbox-dim-content');

		$dim.switchClass( "opaque", "transparent", 400, null, function()
		{
			$dim.hide();
		});
		$lightbox.switchClass( "opaque", "transparent", 400, null, function()
		{
			$lightbox.find('.content').html('<img src="'+templateDirectoryUrl+'/images/ajax-loader-24x24.gif">');
			$lightbox.hide();

			if( typeof navmenu == "object" ) {
				navmenu.show();
			}
		});
	}
}]);